/**
 * @generated SignedSource<<f0b559e22087fade0c6b58cddec0e0b7>>
 * @relayHash 803bd2411b5ccfb7091d5aac3095a48a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6d9f5406464f687f1985513ff8a0101826fc3041b4f0dee81c75ab40777cf9e2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import isJiraCustomTemplatesUxEnabled_provider from '@atlassian/jira-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';
import fetchTeamCount_provider from '@atlassian/jira-relay-provider/src/jira-team-button-team-count.relayprovider';
import showTeamButton_provider from '@atlassian/jira-relay-provider/src/jira-team-button.relayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6d9f5406464f687f1985513ff8a0101826fc3041b4f0dee81c75ab40777cf9e2",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": showTeamButton_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": fetchTeamCount_provider
    }
  }
};

export default node;
